// extracted by mini-css-extract-plugin
export var list = "list-module--list--107ut";
export var item = "list-module--item--3MD14";
export var jsAnimInit = "list-module--jsAnimInit--e2vQ8";
export var item_title = "list-module--item_title--2sUNo";
export var iconsWrap = "list-module--iconsWrap--1rZHr";